import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useSectorsList() {
    const client = ref(JSON.parse(localStorage.getItem('userData')).client)
    const toast = useToast()
    const records = ref(null)
    const tempColumns = ref(null)

    // Table Handler
    if (client.value.type === 0) {
        tempColumns.value = [
            { key: 'market', label: 'Market Center', sortable: false },
            { key: 'tmpNumber', label: 'TMP018 Number', sortable: false },
            { key: 'number', label: 'Sale #', sortable: true },
            { key: 'saleDate', sortable: true },
            { key: 'curing', label: 'T/Type', sortable: false },
            { key: 'isClosed', label: 'Status', sortable: true },
            { key: 'closeDate', label: 'Date Closed', sortable: true },
            { key: 'ticketsCount', label: 'Captured' },
            { key: 'transporter', label: 'Transporter' },
            'actions',
        ]
    } else {
        tempColumns.value = [
            { key: 'market', label: 'Market Center', sortable: false },
            { key: 'number', label: 'Sale #', sortable: true },
            { key: 'saleDate', sortable: true },
            { key: 'isClosed', label: 'Status', sortable: true },
            { key: 'closeDate', label: 'Date Closed', sortable: true },
            { key: 'ticketsCount', label: 'Captured' },
            { key: 'buyer' },
            'actions',
        ]
    }

    const columns = tempColumns.value

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('number')
    const isSortDirDesc = ref(true)
    const locationFilter = ref(null)
    const season_id = ref(null)
    const buyer_id = ref(null)
    const market_id = ref(null)
    const locationType = ref(null)

    const refetch = () => {
        records.value.refresh()
    }

    watch([season_id, buyer_id, market_id, locationFilter, currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-sale/list', {
                location_id: locationFilter.value,
                season_id: season_id.value,
                buyer_id: buyer_id.value,
                market_id: market_id.value,
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { sales, meta } = response.data

                meta.value = meta

                callback(sales)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(error => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching sales list',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = status => {
        if (status) return 'info'
        return 'success'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,

        // resolveUserRoleVariant,
        // resolveUserRoleIcon,
        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,

        // Extra Filters
        // roleFilter,
        // planFilter,
        // statusFilter,
        locationFilter,
        season_id,
        buyer_id,
        market_id,
    }
}
